import { Flex, LocalVideo, RemoteVideo, theme } from '../2022-component-library';
import { Icon } from '../component-library';
import { DefaultButton, FullscreenButton } from '.';
import { useVideo } from '../context/videoContext';
import styled from '@emotion/styled';
import { useAuth } from '../context/authContext';
import { calibrationConstants } from '../helpers/calibration-constants';

const VideoContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 240px;
  height: 160px;
  border-radius: ${calibrationConstants.VIDEO_BORDER_RADIUS}px;
  box-shadow: 0px 11px 22px #b9d5d5;
  position: relative;
`;

const VideoRefreshOverlay = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.2);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 10px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

  & svg {
    display: block !important;
  }
`;

const PatientSidePanel = () => {
  const { disconnect, reconnect } = useVideo();
  const refreshVideo = () => reconnect();
  const { logout } = useAuth();

  const customLogout = () => {
    disconnect();
    logout();
    window.close();
  };

  const LogoutButton = () => {
    return (
      <DefaultButton
        mt='1rem'
        noHover
        type='icon'
        width='240px'
        uppercase
        onClick={() => customLogout()}
        text={'leave session'}
        bg={theme.colors.negativeDark}
      />
    );
  };

  return (
    <Flex column minWidth='300px' height='100vh' minHeight='700px' alignItems='center' marginTop='1.25rem'>
      <VideoContainer marginBottom='1.25rem'>
        <VideoRefreshOverlay onClick={() => refreshVideo()}>
          <Icon icon='loop2' size={15} color='white' />
        </VideoRefreshOverlay>
        <LocalVideo />
      </VideoContainer>
      <VideoContainer marginBottom='2rem'>
        <RemoteVideo />
      </VideoContainer>
      <FullscreenButton />
      <LogoutButton />
    </Flex>
  );
};

export default PatientSidePanel;
